import FormStateActions from './constants';
import { IActionObject, IFieldValue } from './types';

const INITIAL_STATE: any = {};

export default function formStateReducer(
  state: any = INITIAL_STATE,
  action: IActionObject
): object {
  const { data } = action;
  switch (action.type) {
    case FormStateActions.SET_FORM_STATE:
      // Overwrites state with new field key-val pairs
      return {
        ...data.reduce(
          (accumulatorState: any, { fieldKey, fieldValue }: IFieldValue) =>
            Object.assign(accumulatorState, { [fieldKey]: fieldValue }),
          state
        ),
      };
    case FormStateActions.RESET_FORM_STATE:
      // Resets to Empty Object
      return {};
    default:
      return state;
  }
}
